export default class {
  constructor(callback, delay) {
    this.callback = callback;
    this.timeoutId = null;
    this.start = Date.now();
    this.remaining = delay;

    this.resume();
  }

  pause() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
      this.remaining -= Date.now() - this.start;
    }
  }

  resume() {
    if (this.timeoutId) {
      return;
    }

    this.start = Date.now();
    this.timeoutId = window.setTimeout(this.callback, this.remaining);
  }

  clear() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
    }
  }
}
